import { useQuery } from '@tanstack/react-query';
import gqlFetcher from '../gqlFetcher';
export const useAuthedQuery = ({
  queryKey,
  ...rest
}) => useQuery({
  ...rest,
  queryKey: ['authed'].concat(queryKey)
});
export const useGqlQuery = (query, vars, options) => useAuthedQuery({
  ...options,
  queryFn: () => gqlFetcher(query, vars)
});
export const useUnauthedGqlQuery = (query, vars, options) => useQuery({
  ...options,
  queryFn: () => gqlFetcher(query, vars)
});